import React from 'react';
import styled from 'astroturf/react';

import {
  PackPreviewRows,
  PackPreviewFade,
} from 'js/liswp_blocks/shared/PackPreviewRows';
import { Work as SidebarWork } from 'js/liswp/Sidebar/hooks/types';

import { DownloadHeroCard, DownloadHeroCardProps } from './DownloadHeroCard';
import { DownloadModalPackPreview } from '../types';

const MODAL_PREVIEW_ROWS = 4;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
  border-radius: var(--border-radius-radius-md, 8px);
`;

const TopPanel = styled.div`
  @import 'stylesheets/design_system/breakpoint';

  padding: 36px var(--spacing-sm-24, 24px) 20px 20px;
  background: var(--background-light-blue, #eef2f9);

  @include breakpoint(small, medium) {
    padding: 36px var(--spacing-xs-12, 12px) 20px;
  }
`;

const RowsPanel = styled.div`
  @import 'stylesheets/design_system/breakpoint';

  position: relative;
  height: 288px;
  overflow: hidden;
  padding: 0 var(--spacing-md-40, 40px);
  background: var(--background-light-blue, #eef2f9);

  @include breakpoint(small, medium) {
    padding: 0 var(--spacing-xs-16, 16px);
  }
`;

export type DownloadPackPreviewProps = {
  packPreview: DownloadModalPackPreview;
  card: Omit<DownloadHeroCardProps, 'mode' | 'relatedCount'>;
};

export const DownloadPackPreview: React.FC<DownloadPackPreviewProps> = ({
  packPreview,
  card,
}) => {
  const rows = packPreview.relatedWorks.slice(0, MODAL_PREVIEW_ROWS);
  const rowYears = Object.fromEntries(
    rows
      .filter((row) => row.year != null)
      .map((row) => [String(row.id), row.year as number]),
  );

  return (
    <Wrapper>
      <TopPanel>
        <DownloadHeroCard
          {...card}
          mode="pdf_pack"
          relatedCount={packPreview.relatedCount}
        />
      </TopPanel>
      <RowsPanel>
        <PackPreviewRows
          variant="pickDownload"
          relatedWorks={rows as unknown as SidebarWork[]}
          rowViews={packPreview.rowViews ?? {}}
          rowYears={rowYears}
          thumbChips
          meta="yearviews"
          showRelevancy={packPreview.showRelevancy ?? true}
        />
        {packPreview.relatedCount > 0 && (
          <PackPreviewFade relatedCount={packPreview.relatedCount} />
        )}
      </RowsPanel>
    </Wrapper>
  );
};

export default DownloadPackPreview;
